import { createSlice } from "@reduxjs/toolkit";
import { removeData } from "jquery";

const initialState = {
  subusers: [],
};
export const subuserSlice = createSlice({
  name: "subuser",
  initialState,
  reducers: {
    addSubuser: (state, action) => {
      state.subusers = [];
      state.subusers.push(action.payload);
    },
    // removeUser: (state, action) => {
    //   state.users = state.users.filter((user) => user.userid !== action.payload);
    // },

    updateSubuser: (state, action) => {
      state.subusers = state.subusers.map((subuser) => {
        if (subuser.userid === action.payload.userid) {
          return action.payload;
        }
        return subuser;
      });
    },
    deleteSubUser: (state, action) => {
      state.subusers = state.subusers.filter((subuser) => subuser !== action.payload);
      removeData("subusers/" + action.payload);
    },
  },
});

export const { addSubuser, updateSubuser, deleteSubUser } = subuserSlice.actions;

export default subuserSlice.reducer;
